/**
 * Please don't add any further fucntion to this file. Re use the function for your events.
 */
import { GetCurrentPatients_getCurrentPatients_patients } from "graphql/types/GetCurrentPatients";
import { Gender } from "graphql/types/globalTypes";
import useMobileDetect from "helpers/useMobileDetect";

declare global {
  interface Window {
    clevertap: any;
    Juspay: any;
  }
}

if (typeof window !== "undefined") {
  window.clevertap = window.clevertap || {};
}

export const clevertapPushNotification = () => {
  if (typeof window !== "undefined") {
    try {
      window.clevertap.notifications.push({
        titleText: `<img src="${process.env.NEXT_PUBLIC_247_CDN_URL}/images/honk_01.gif" />`,
        bodyText:
          "<h3> Never miss the latest updates and offers!</h3> <p>Get instant notifications from Apollo 24|7</p>",
        okButtonText: "Yes, I'm on Board",
        rejectButtonText: "Later",
        okButtonColor: "#fff",
        serviceWorkerPath: "/service-worker.js",
      });
    } catch (err) {
      console.error("Clevertap push notification tracking err: ", err);
    }
  }
};

export const updateUserProfileUTMSource = (utm_source) => {
  if (typeof window !== "undefined") {
    try {
      window.clevertap.profile.push({
        Site: {
          utm_source: utm_source,
        },
      });
    } catch (err) {
      console.error("Clevertap user login tracking err: ", err);
    }
  }
};

export const clevertapUserLoginTracking = (
  userData: GetCurrentPatients_getCurrentPatients_patients,
  data: any = undefined
) => {
  if (typeof window !== "undefined") {
    try {
      window.clevertap.onUserLogin.push({
        Site: {
          Name: userData.firstName + " " + (userData.lastName || ""),
          UHID: userData.uhid || "",
          "MSG-whatsapp": data?.whatsappOptIn,
          Identity: userData.mobileNumber.slice(3) || "",
          MobileNumber: userData.mobileNumber || "",
          Phone: userData.mobileNumber || "",
          Firstname: userData.firstName || "",
          ...(userData.lastName && { Lastname: userData.lastName }),
          Relation: userData.relation || "",
          Gender:
            userData.gender == Gender.MALE
              ? "M"
              : userData.gender == Gender.FEMALE
              ? "F"
              : "",
          DOB: new Date(userData.dateOfBirth),
          ...(userData.emailAddress && { Email: userData.emailAddress }),
          ...(userData.photoUrl && { Photo: userData.photoUrl }),
          ...(userData.createdDate && { CreatedDate: userData.createdDate }),
        },
      });
    } catch (err) {
      console.error("Clevertap user login tracking err: ", err);
    }
  }
};

export const clevertapUserLogoutTracking = () => {
  if (typeof window !== "undefined") {
    try {
      window.clevertap.logout();
    } catch (err) {
      console.error("Clevertap user logout tracking err: ", err);
    }
  }
};

export function eventTracking(eventName: string, data: any = undefined) {
  const isMobile = useMobileDetect()?.isMobile() ?? false;
  const eventData = data
    ? { ...data, platform: isMobile ? "M-web" : "web" }
    : undefined;
  Promise.all([clevertapTracking(eventName, eventData)]);
}

const linearisedObject = (data: object): object => {
  // convert all the values of each key into string
  Object.keys(data).forEach((key) => {
    if (typeof data[key] == "object") {
      data[key] = JSON.stringify(data[key]);
    }
  });
  return data;
};

export const clevertapTracking = (eventName: string, data: any = undefined) => {
  try {
    if (typeof window !== "undefined" && window?.clevertap?.event) {
      if (data) {
        if (typeof data == "object") {
          data = linearisedObject(data);
        }
        window.clevertap.event.push(eventName, data);
      } else {
        window.clevertap.event.push(eventName);
      }
    }
  } catch (err) {
    console.error("Clevertap Err: ", err);
  }
};

export const clevertapChargedTracking = (
  eventName: string,
  data: any = undefined
) => {
  try {
    if (typeof window !== "undefined" && window?.clevertap?.event) {
      if (data) {
        window.clevertap.event.push(eventName, data);
      } else {
        window.clevertap.event.push(eventName);
      }
    }
  } catch (err) {
    console.error("Clevertap Err: ", err);
  }
};

/**
 * Please don't add any further fucntion to this file. Re use the function for your events.
 */
export default clevertapTracking;
